import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addProjects, deleteProject, fetchProjects, updateProject } from "./ProjectAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchProjectsAsync = createAsyncThunk(
  "Projects/fetch",
  async () => {
    // console.log("token in fetchProject:- ", token)
    try {
      const data = await fetchProjects();

      const resp = data?.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return error
      // return rejectWithValue(error.message);
    }
  }
);

export const deleteProjectAsync = createAsyncThunk(
  "Projects/delete",
  async ({uuid}) => {
    try {
      await deleteProject(uuid);
      return uuid;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const updateProjectAsync = createAsyncThunk(
  "Projects/update",
  async ({ uuid, projectData }, { rejectWithValue }) => {
    try {
      const response = await updateProject( uuid, projectData);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addProjectAsync = createAsyncThunk(
  "Projects/add",
  async ({ newProject}) => {
    try {
      const data = await addProjects( newProject);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const ProjectsSlice = createSlice({
  name: "Projects",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchProjectsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addProjectAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addProjectAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })
      
      .addCase(updateProjectAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjectAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedProjectIndex = state.data.findIndex(
            (projectData) => projectData.id === action.payload.id
          );
      
          if (updatedProjectIndex !== -1) {
            state.data[updatedProjectIndex] = action.payload;
          }
        } else {
          state.data = [action.payload]; // Fallback: set the state to an array with the updated project
        }
      })
      
      .addCase(updateProjectAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      })
      .addCase(deleteProjectAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProjectAsync.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure state.data is an array before filtering
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((project) => project.id !== action.payload);
        } else {
          console.error("state.data is not an array");
        }
      })
      .addCase(deleteProjectAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
      
  },
});

export const selectProjects = (state) => state.candidateProjects?.data?.projects;

export default ProjectsSlice.reducer;
